export default {
  PROFILE ({ profile }) {
    return profile
  }
}
